import PageHero from "../components/PageHero";
import TerminalWindow from "../components/TerminalWindow";
import SectionHeading from "../components/SectionHeading";

const PUB = process.env.PUBLIC_URL || "";

const EXECS = [
  {
    name: "Lee Rosen",
    role: "President",
    quote: "I am an avid Cactus fan.",
    photo: `${PUB}/uploads/2018/08/fff38920218_117739482497186_7670090946683338752_o.jpg`,
    accent: "magenta",
    file: "lrosen.exe",
  },
  {
    name: "Lonny Geller",
    role: "Vice President",
    quote: "I also adore the man with the pants.",
    photo: `${PUB}/uploads/2018/08/fff.jpg`,
    accent: "cyan",
    file: "lgeller.exe",
  },
  {
    name: "Sarah Elaz",
    role: "Executive Director of Dance Operations & Social Media",
    quote: "They dance to Trey, I dance to Mike.",
    photo: `${PUB}/uploads/2018/08/SarahElaz.png`,
    accent: "orange",
    file: "selaz.exe",
  },
];

const BOARD = [
  {
    name: "Rachel Loonin Steinerman",
    role: "Phunky Balabusta",
    quote: "This balabusta gets down.",
    photo: `${PUB}/uploads/2018/12/loony.png`,
    accent: "lime",
    file: "rls.exe",
  },
];

function ExecCard({ person }) {
  const accent = {
    magenta: "#FF00FF",
    cyan: "#00FFFF",
    orange: "#FF9900",
    lime: "#9FFF00",
  }[person.accent];

  return (
    <article className="group relative flex flex-col bg-mgfc-card/60 backdrop-blur-md transition-transform duration-200 ease-linear hover:-translate-y-1.5">
      <span
        className="pointer-events-none absolute inset-x-0 top-0 h-[2px]"
        style={{ background: accent }}
      />
      <span
        className="pointer-events-none absolute inset-y-0 left-0 w-px opacity-50"
        style={{ background: accent }}
      />
      <span
        className="pointer-events-none absolute inset-y-0 right-0 w-px opacity-50"
        style={{ background: accent }}
      />
      <span
        className="pointer-events-none absolute inset-x-0 bottom-0 h-px opacity-30"
        style={{ background: accent }}
      />
      <span
        className="pointer-events-none absolute -inset-px opacity-0 transition-opacity duration-200 group-hover:opacity-100"
        style={{
          boxShadow: `0 0 30px ${accent}66, inset 0 0 0 1px ${accent}66`,
        }}
      />

      {/* Photo with duotone */}
      <div className="relative aspect-[4/5] overflow-hidden bg-black">
        <img
          src={person.photo}
          alt={person.name}
          className="h-full w-full object-cover grayscale contrast-110 transition-transform duration-700 group-hover:scale-105"
          draggable={false}
        />
        <div
          className="absolute inset-0 mix-blend-screen opacity-60"
          style={{
            background: `linear-gradient(135deg, ${accent}66 0%, transparent 70%)`,
          }}
        />
        <div
          className="absolute inset-0 mix-blend-multiply"
          style={{
            background: `linear-gradient(180deg, transparent 40%, ${accent}33 100%)`,
          }}
        />
        <div
          className="absolute inset-x-0 bottom-0 h-1/2"
          style={{
            background:
              "linear-gradient(180deg, transparent 0%, rgba(9,0,20,0.85) 100%)",
          }}
        />
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-3 p-4 font-mono text-[10px] uppercase tracking-[0.3em] text-mgfc-fg/60">
          <span>// {person.file}</span>
          <span style={{ color: accent }}>● rec</span>
        </div>
      </div>

      <div className="relative p-6">
        <p
          className="font-mono text-[11px] uppercase tracking-[0.4em]"
          style={{ color: accent }}
        >
          {person.role}
        </p>
        <h3
          className="mt-2 font-display text-2xl font-black uppercase leading-tight tracking-tight text-mgfc-fg"
          style={{ textShadow: `0 0 18px ${accent}55` }}
        >
          {person.name}
        </h3>
        <p className="mt-4 border-l-2 pl-3 font-mono text-sm leading-relaxed text-mgfc-fg/75"
          style={{ borderColor: `${accent}99` }}
        >
          <span className="mr-2 opacity-50">"</span>
          {person.quote}
          <span className="ml-1 opacity-50">"</span>
        </p>
      </div>
    </article>
  );
}

export default function TeamPage() {
  return (
    <>
      <PageHero
        eyebrow="MGFC // org chart"
        title="The Team"
        tagline="◢ The wonderful fools who make this all possible ◣"
        image={`${PUB}/uploads/2018/08/DjhBAnMU4AEbjiu.jpg`}
        accent="orange"
      />

      {/* C-LEVEL EXECS WINDOW -------------------------------------------------- */}
      <section className="mx-auto max-w-7xl px-4 pt-20 sm:px-6 lg:px-8">
        <TerminalWindow
          title="C:\MGFC\TEAM\C-LEVEL\"
          status="3 RECORDS"
          accent="cyan"
        >
          <div className="p-6 sm:p-10">
            <div className="mb-10 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
              <SectionHeading
                eyebrow="// senior management"
                title="C-Level Executives"
                accent="cyan"
              />
              <p className="max-w-md font-mono text-sm leading-relaxed text-mgfc-fg/65">
                The highest-level executives in senior management.
                <br />
                Their authority extends from the soundboard to the dance floor.
              </p>
            </div>
            <div className="grid gap-6 md:grid-cols-3">
              {EXECS.map((p) => (
                <ExecCard key={p.name} person={p} />
              ))}
            </div>
          </div>
        </TerminalWindow>
      </section>

      {/* BOARD ---------------------------------------------------------------- */}
      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <TerminalWindow
          title="C:\MGFC\TEAM\BOARD\"
          status="1 RECORD"
          accent="lime"
        >
          <div className="p-6 sm:p-10">
            <div className="mb-10 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
              <SectionHeading
                eyebrow="// governance"
                title="Board of Directors"
                accent="lime"
              />
              <p className="max-w-md font-mono text-sm leading-relaxed text-mgfc-fg/65">
                They make the rules.
                <br />
                The rules are: get down.
              </p>
            </div>
            <div className="grid gap-6 md:grid-cols-3">
              {BOARD.map((p) => (
                <ExecCard key={p.name} person={p} />
              ))}
              <div className="col-span-1 hidden md:col-span-2 md:block" aria-hidden />
            </div>
          </div>
        </TerminalWindow>
      </section>

      {/* HIRING --------------------------------------------------------------- */}
      <section className="mx-auto max-w-4xl px-4 pb-24 sm:px-6 lg:px-8">
        <div className="border-2 border-dashed border-mgfc-magenta/40 bg-mgfc-card/40 p-8 text-center sm:p-12">
          <p className="font-mono text-xs uppercase tracking-[0.4em] text-mgfc-magenta">
            // open roles
          </p>
          <p className="mt-4 font-display text-2xl font-black uppercase tracking-tight text-mgfc-fg sm:text-3xl">
            We are hiring{" "}
            <span className="gradient-text-mike">unpaid weirdos</span>
          </p>
          <p className="mt-4 font-mono text-base leading-relaxed text-mgfc-fg/70">
            Sploof Editor // Pant Correspondent // Director of Cosmic Whisperings
          </p>
          <a
            href="mailto:help@mikegordonfanclub.com"
            className="mt-6 inline-block font-mono text-sm uppercase tracking-[0.35em] text-mgfc-cyan hover:text-glow-cyan"
          >
            ▸ apply at help@mikegordonfanclub.com
          </a>
        </div>
      </section>
    </>
  );
}
